interface DmFancybetOddsTypeConst {
  DMFANCYBET: number
  DMFANCYBETPLUS: number
}

const dmFancybetOddsTypeConst: DmFancybetOddsTypeConst = Object.freeze({
  DMFANCYBET: 1,
  DMFANCYBETPLUS: 0
})

export default dmFancybetOddsTypeConst
